function extractDateComponents(dateString: string) {
  // Split the date string into an array [year, month, day]
  const parts = dateString.split("-");

  // Extract year, month, and day as integers
  const year = parseInt(parts[0], 10);
  const month = parseInt(parts[1], 10);
  const day = parseInt(parts[2], 10);

  // Return an object containing the year, month, and day
  return { year, month: month - 1, day };
}

const createDate = (yearMonthDay: string) => {
  const { year, month, day } = extractDateComponents(yearMonthDay);
  const result = new Date(year, month, day);
  // result.setHours(result.getHours() + 8); //add 7 hours for PST time zone
  return result;
};

export const getDatesInRange = (
  startDate: string,
  endDate: string,
): ConvertedBooking => {
  const convertedStart = createDate(startDate);
  const endingDate = createDate(endDate);
  return { start: convertedStart, end: endingDate, title: "Booked" };
};

interface GoogleBooking {
  start: {
    date?: string;
    dateTime?: string;
  };
  end: {
    date?: string;
    dateTime?: string;
  };
}

export interface ConvertedBooking {
  start: Date;
  end: Date;
  title: string;
}

// The venue is closed to events over the winter; shown alongside real bookings.
export const WINTER_CLOSURE: ConvertedBooking = {
  start: createDate("2026-12-01"),
  end: createDate("2027-03-01"),
  title: "Closed for winter",
};

// All-day events carry `date`; timed events carry `dateTime`. Normalize to
// the calendar day so both kinds of booking render as blocked days.
const toDayString = (boundary: { date?: string; dateTime?: string }) =>
  boundary.date ?? boundary.dateTime?.slice(0, 10);

export const getBookingsList = (
  bookings: GoogleBooking[],
  extraEvents: ConvertedBooking[] = [],
) => {
  const result: ConvertedBooking[] = [];
  bookings.forEach((booking) => {
    const start = toDayString(booking.start);
    const end = toDayString(booking.end);
    if (start && end) {
      result.push(getDatesInRange(start, end));
    }
  });
  result.push(...extraEvents);
  return result;
};
